import { takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnDestroy, OnInit } from '@angular/core';
import { OrganisationInvitationBannerComponent } from '@organisations/components/banners/organisation-invitation-banner/organisation-invitation-banner.component';
import { IOrganisationAndOrganisationUser } from '@organisations/models/organisation-user';
import { OrganisationUserService } from '@organisations/services/organisation-user/organisation-user.service';
import { AlertComponent } from '@shared/components/alerts/alert/alert.component';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';

@Component({
	selector: 'app-organisation-invites',
	imports: [CommonModule, LoadingStateComponent, OrganisationInvitationBannerComponent, AlertComponent],
	templateUrl: './organisation-invites.component.html',
	styleUrl: './organisation-invites.component.scss',
})
export class OrganisationInvitesComponent implements OnInit, OnDestroy {
	private organisationUserService = inject(OrganisationUserService);

	organisationInvitations: Array<IOrganisationAndOrganisationUser> = [];

	destroyed$ = new EventEmitter<void>();

	isLoading = true;

	ngOnInit(): void {
		this.organisationUserService
			.organisationInvitations()
			.pipe(takeUntil(this.destroyed$))
			.subscribe((organisationInvitations) => {
				this.organisationInvitations = organisationInvitations;
				this.isLoading = false;
			});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
